import { $emit as d, $children as p } from "../utils/gogocodeTransfer.js";
import "../icon/index.js";
import { resolveComponent as u, openBlock as c, createElementBlock as h, createElementVNode as m, toDisplayString as b, createVNode as y, normalizeClass as g } from "vue";
import { _ as x } from "../_plugin-vue_export-helper-dad06003.js";
import { I as $ } from "../icon-51ff7679.js";
import "../util-b2b0dc25.js";
function _(t) {
  return typeof t.render == "function" || typeof t.setup == "function";
}
const C = {
  name: "rQueryTableFilterButton",
  components: {
    RIcon: $
  },
  props: {
    /**
     * 展开状态
     */
    value: {
      type: Boolean,
      default: !1
    },
    /**
     * 指定需要关联的r-query-table组件，默认情况下它会自动关联页面中出现的第一个table组件
     */
    table: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      expanded: this.value
    };
  },
  methods: {
    // 查找关联table
    // 简化难度
    // 从根节点开始查找，查找到第一个或者指定了ref 名字的 名字时的那一个时，即停止
    // 如果指定了table的ref name，则直接找它
    findRelativeTableRefs() {
      const t = "rQueryTable", i = [], a = [], l = function(e) {
        i.push(e);
        const r = Object.keys(e.$refs);
        r.length > 0 && r.forEach((n) => {
          _(e.$refs[n]) && a.push(e.$refs[n]);
        }), p(e).length > 0 && p(e).forEach((n) => {
          l(n);
        });
      };
      return l(this.$root), this.table ? a.reverse().find((e) => {
        var r, n;
        return ((n = (r = e == null ? void 0 : e.$vnode) == null ? void 0 : r.data) == null ? void 0 : n.ref) === this.table;
      }) : i.reverse().find((e) => {
        var r, n, o, f;
        return ((f = (o = (n = (r = e == null ? void 0 : e.$vnode) == null ? void 0 : r.componentOptions) == null ? void 0 : n.Ctor) == null ? void 0 : o.options) == null ? void 0 : f.name) === t;
      });
    },
    // 改变关联表格筛选项的可见性
    changeRelativeTableFilterVisibility() {
      const t = this.findRelativeTableRefs();
      t && t.changeFilterVisible && t.changeFilterVisible();
    },
    onChange() {
      this.expanded = !this.expanded, this.changeRelativeTableFilterVisibility(), d(this, "update:value", this.expanded), d(this, "change", this.expanded);
    },
    // 变更过滤器的可见性，用于table调用
    changeExpanded() {
      this.expanded = !this.expanded;
    }
  },
  watch: {
    value() {
      this.expanded = this.value, this.changeRelativeTableFilterVisibility();
    }
  },
  mounted() {
  },
  emits: ["update:value", "change"]
};
function R(t, i, a, l, e, r) {
  const n = u("r-icon");
  return c(), h("span", {
    class: "r-query-table-filter-button",
    onClick: i[0] || (i[0] = (...o) => r.onChange && r.onChange(...o))
  }, [
    m(
      "span",
      null,
      b(e.expanded ? t.$t("bmui-query-table-filter-button.fold") : t.$t("bmui-query-table-filter-button.expand")),
      1
      /* TEXT */
    ),
    y(n, {
      class: g(["r-query-table-filter-button-icon", e.expanded ? "is-top" : ""]),
      name: "icon-caret_down"
    }, null, 8, ["class"])
  ]);
}
const s = /* @__PURE__ */ x(C, [["render", R], ["__file", "/Users/dave/Documents/dev/bmui3/src/packages/query-table-filter-button/query-table-filter-button.vue"]]);
s.install = function(t) {
  t.component(s.name, s);
};
export {
  s as default
};
